// src/utils/commonEnums/countries.ts
var countriesAlpha2 = {
  AF: "Afghanistan",
  AX: "\xC5land Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia (Plurinational State of)",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CD: "Congo (the Democratic Republic of the)",
  CG: "Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Cura\xE7ao",
  CY: "Cyprus",
  CZ: "Czechia",
  CI: "C\xF4te d'Ivoire",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands [Malvinas]",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran (Islamic Republic of)",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea (the Democratic People's Republic of)",
  KR: "Korea (the Republic of)",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia (Federated States of)",
  MD: "Moldova (the Republic of)",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine, State of",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  MK: "Republic of North Macedonia",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  RE: "R\xE9union",
  BL: "Saint Barth\xE9lemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  UM: "United States Minor Outlying Islands",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivarian Republic of)",
  VN: "Viet Nam",
  VG: "Virgin Islands (British)",
  VI: "Virgin Islands (U.S.)",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
};
var offset = 127397;
function toEmoji(countryCode) {
  const f = countryCode.codePointAt(0);
  const s = countryCode.codePointAt(1);
  return String.fromCodePoint(f + offset) + String.fromCodePoint(s + offset);
}
var countriesAlpha2Emojis = Object.keys(countriesAlpha2).reduce(
  (acc, countryCode) => ({
    ...acc,
    [countryCode]: toEmoji(countryCode)
  }),
  {}
);
var toCountryLabel = (country) => {
  return countriesAlpha2[country];
};

// src/utils/commonEnums/states.ts
var usStates = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "Washington DC",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};
var canadianProvinces = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon"
};
var byCountry = {
  US: usStates,
  CA: canadianProvinces
};
var flatStates = Object.assign({}, ...Object.values(byCountry));
var statesWithNamesForCountry = (country) => {
  if (country in byCountry) {
    return byCountry[country];
  }
  return [];
};
var statesForCountry = (country) => {
  if (country in byCountry) {
    return Object.keys(byCountry[country]);
  }
  return [];
};
var getStateOptions = (country) => {
  const countryStates = country ? statesWithNamesForCountry(country) : [];
  return Object.entries(countryStates).map(([value, label]) => ({
    value,
    label
  }));
};
var isRegionState = (region) => {
  return region !== void 0 && region in flatStates;
};

// src/utils/errorHandling.ts
var isSequenceApiError = (error) => error !== null && typeof error === "object" && "status" in error && "statusText" in error;
var isSequenceApiErrorResponse = (errorResponse) => !!errorResponse && typeof errorResponse === "object" && "error" in errorResponse;
var isQuickBooksErrorResponse = (errorResponse) => !!errorResponse && typeof errorResponse === "object" && "Fault" in errorResponse;

// src/utils/queryHooks.ts
import {
  useQuery as tanStackQuery,
  useMutation as tanStackMutation,
  useInfiniteQuery as tanStackInfiniteQuery,
  useQueryClient
} from "@tanstack/react-query";
import { useEffect } from "react";
function useQuery(apiFunction, apiFunctionParams = void 0, config = {}) {
  invariantOnInvalidSequenceAPIFunction(apiFunction);
  const { queryKey: queryKeyFromConfig, ...queryConfig } = config;
  const queryKey = [
    ...queryKeyFromConfig || [],
    ...apiFunction.queryKey,
    ...apiFunctionParams ? [apiFunctionParams] : []
  ];
  return tanStackQuery({
    ...queryConfig,
    queryKey,
    queryFn: async () => {
      const res = await apiFunction.request(apiFunctionParams);
      if (res && typeof res === "object" && "error" in res && res?.error) {
        const errorResponse = await res.res.json().catch(() => void 0);
        return Promise.reject({
          statusText: res.res.statusText,
          status: res.res.status,
          response: errorResponse
        });
      }
      return res.data ?? null;
    }
  });
}
var useComplexQuery = tanStackQuery;
var invalidateQueries = (queryClient) => async (queriesToInvalidate) => {
  if (!queriesToInvalidate || !queriesToInvalidate?.length) {
    return;
  }
  const queriesAsList = Array.isArray(queriesToInvalidate) ? queriesToInvalidate : [queriesToInvalidate];
  await Promise.all(
    queriesAsList.map((queryKeyToInvalidate) => {
      const stringifiedQueryKey = typeof queryKeyToInvalidate === "string" ? queryKeyToInvalidate : queryKeyToInvalidate.join(".");
      queryClient.invalidateQueries({
        predicate: (query) => {
          return query.queryKey.join(".").includes(stringifiedQueryKey);
        }
      });
    })
  );
};
var useRunInvalidationForMutation = () => {
  const queryClient = useQueryClient();
  return (sequenceApiMutationFn) => invalidateQueries(queryClient)(
    sequenceApiMutationFn.invalidateQueries ?? []
  );
};
function useMutation(apiFunction, config = {}) {
  const queryClient = useQueryClient();
  invariantOnInvalidSequenceAPIFunction(apiFunction);
  return tanStackMutation({
    ...config,
    mutationFn: async (variables) => {
      const res = await apiFunction.request(variables);
      if (res && typeof res === "object" && "error" in res && res?.error) {
        const errorResponse = await res.res.json().catch(() => void 0);
        return Promise.reject({
          statusText: res.res.statusText,
          status: res.res.status,
          response: errorResponse
        });
      }
      return res.data;
    },
    onSuccess: (data, variables, context) => {
      if (config.onSuccess) {
        config.onSuccess(data, variables, context);
      }
      if (config.invalidateQueries) {
        const queriesToInvalidate = config.invalidateQueries(
          apiFunction?.invalidateQueries || []
        );
        invalidateQueries(queryClient)(queriesToInvalidate);
      } else {
        invalidateQueries(queryClient)(apiFunction.invalidateQueries);
      }
    }
  });
}
function useInfiniteQuery(apiFunction, apiFunctionParams, config) {
  invariantOnInvalidSequenceAPIFunction(apiFunction);
  const { queryKey: queryKeyFromConfig, ...queryConfig } = config;
  const queryKey = [
    ...queryKeyFromConfig || [],
    ...apiFunction.queryKey,
    ...apiFunctionParams ? [apiFunctionParams] : [],
    "infinite"
  ];
  return tanStackInfiniteQuery({
    ...queryConfig,
    queryKey,
    queryFn: async (context) => {
      const res = await apiFunction.request({
        ...context.pageParam ?? {},
        ...apiFunctionParams
      });
      if (res && typeof res === "object" && "error" in res && res?.error) {
        throw new Error("Could not fetch");
      }
      return res.data;
    }
  });
}
var useApiQueryClient = useQueryClient;
var isValidSequenceAPIFunction = (fn) => {
  return "request" in fn;
};
var invariantOnInvalidSequenceAPIFunction = (fn) => {
  if (!isValidSequenceAPIFunction(fn)) {
    throw new Error(
      "Incompatible query function provided, please use sequence API function"
    );
  }
};
function useLoadAllItemsQuery(apiFn, queryParams = {}, maxPages = 16, config = {}) {
  const infiniteQuery = useInfiniteQuery(apiFn, queryParams, {
    ...config,
    staleTime: 1e3 * 5,
    initialPageParam: { before: void 0, after: void 0 },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || allPages.length >= maxPages) {
        return null;
      }
      const {
        pagination: { before, after },
        items
      } = lastPage;
      if (!after || !items.length) {
        return null;
      }
      return { before, after };
    }
  });
  useEffect(() => {
    if (infiniteQuery.hasNextPage && !infiniteQuery.isFetchingNextPage) {
      void infiniteQuery.fetchNextPage();
    }
  }, [
    infiniteQuery.hasNextPage,
    infiniteQuery.isFetchingNextPage,
    infiniteQuery.fetchNextPage
  ]);
  return infiniteQuery;
}

// src/utils/useSequenceInfiniteQuery.ts
import omit from "lodash/fp/omit";
var MAX_PAGES = 16;
var useSequenceInfiniteQueryHook = (apiFn, queryParams = {}, additionalConfig = {}) => {
  const maxPages = additionalConfig.maxPages ?? MAX_PAGES;
  const infiniteQuery = useInfiniteQuery(apiFn, queryParams, {
    staleTime: 1e3 * 5,
    // 5s
    initialPageParam: { before: void 0, after: void 0 },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage || allPages.length >= maxPages) {
        return null;
      }
      const {
        pagination: { before, after },
        items
      } = lastPage;
      if (!after || !items.length) {
        return null;
      }
      return { before, after };
    },
    ...omit("maxPages")(additionalConfig)
  });
  return { infiniteQuery };
};
var useSequenceInfiniteQuery = Object.assign(
  useSequenceInfiniteQueryHook,
  {
    MAX_PAGES
  }
);

// src/utils/createApiQueryClient.ts
import { QueryClient } from "@tanstack/react-query";
import deepmerge from "deepmerge";
var BASE_CONFIG = {
  defaultOptions: {
    queries: {
      gcTime: 1e3 * 60 * 30
      // 30 minutes
    }
  }
};
var createApiQueryClient = (config) => {
  return new QueryClient(deepmerge(BASE_CONFIG, config ?? {}));
};

// src/utils/createApiQueryPersister.ts
import { get, set, del } from "idb-keyval";
var DEFAULT_KEY = "reactQuery";
function createApiQueryPersister(idbValidKey = DEFAULT_KEY) {
  return {
    persistClient: async (client) => {
      await set(idbValidKey, JSON.stringify(client));
    },
    restoreClient: async () => {
      const serializedClient = await get(idbValidKey);
      if (!serializedClient) {
        return;
      }
      try {
        return serializedClient && JSON.parse(serializedClient);
      } catch {
        return;
      }
    },
    removeClient: async () => {
      await del(idbValidKey);
    }
  };
}
export {
  canadianProvinces,
  countriesAlpha2,
  countriesAlpha2Emojis,
  createApiQueryClient,
  createApiQueryPersister,
  getStateOptions,
  isQuickBooksErrorResponse,
  isRegionState,
  isSequenceApiError,
  isSequenceApiErrorResponse,
  statesForCountry,
  statesWithNamesForCountry,
  toCountryLabel,
  usStates,
  useApiQueryClient,
  useComplexQuery,
  useInfiniteQuery,
  useLoadAllItemsQuery,
  useMutation,
  useQuery,
  useRunInvalidationForMutation,
  useSequenceInfiniteQuery
};
//# sourceMappingURL=index.js.map